// Path: ./src/hooks/useProductTagOptions.ts
import { useState, useEffect, useCallback } from "react";
import { adminApiService } from "../utils/api";
import { GfProductTag } from "@swagger/typescript-fetch-goflyer";

export const useProductTagOptions = () => {
  const [productTagOptionList, setProductTagOptionList] =
    useState<GfProductTag[]>();

  const fetchProductTags = useCallback(async () => {
    try {
      const productTagData =
        await adminApiService.getManyBaseGfProductTagAdminControllerGfProductTag();

      setProductTagOptionList(productTagData.data);
    } catch (error) {
      console.error("Error fetching product tags:", error);
    }
  }, []);

  useEffect(() => {
    fetchProductTags();
  }, []);

  return { productTagOptionList, fetchProductTags };
};
